import { api } from '~/services/api';

const MODULE_URL = 'user';
const ADMIN_MODULE_URL = 'admin/user';

interface SearchNetworkParams {
  skip?: number;
  limit?: number;
  name?: string;
  skills?: unknown;
  position?: Object;
  ecosystems?: string;
}

export default class UserService {
  static async me() {
    return await api.get(`${MODULE_URL}/me`);
  }

  static async get(id: string) {
    return await api.get(`${MODULE_URL}/${id}`);
  }

  static async deleteById(id: string) {
    return await api.delete(`${MODULE_URL}/${id}`);
  }
}

export class AdminUserService {
  static async search(params: SearchNetworkParams) {
    if (params.skills) {
      params.skills = JSON.stringify(params.skills);
    }
    if (params.position) {
      params.position = JSON.stringify(params.position);
    }
    return await api.get(`${ADMIN_MODULE_URL}/search`, { params });
  }
}
